import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useReplaceMeterStepsStore } from '../../useStepsStore';
import { Button } from '../../../../components/Button/Button';
import { DETAILS_FORM_ID } from './constants';
import { DetailsStepFooter as messages } from './messages';

export const DetailsStepFooter: VFC = () => {
  const { setPreviousStep } = useReplaceMeterStepsStore();

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>

      <Button key="submit" block form={DETAILS_FORM_ID} htmlType="submit" type="primary">
        <FormattedMessage {...messages.next} />
      </Button>
    </>
  );
};
